<p-confirmDialog [style]="{ width: '380px' }"></p-confirmDialog>

<div class="vendor-bill-popup">
  <div class="bill-header">
    <div>
      <h4>Vendor Billing</h4>
      <span>{{ selectedOrders.length }} order selected</span>
    </div>
    <span class="vendor-chip">{{ selectedOrders[0]?.vendorName || 'Vendor' }}</span>
  </div>

  <div *ngIf="loading" class="loading-state">
    <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
    <span>Loading trip and claim details...</span>
  </div>

  <ng-container *ngIf="!loading">
    <section class="bill-section" [formGroup]="invoiceForm">
      <div class="section-title">
        <span class="section-count">1</span>
        <span>Trip Reference</span>
      </div>

      <div formArrayName="trips">
        <div class="trip-card" *ngFor="let row of tripRows; let i = index" [formGroupName]="i">
          <div class="trip-card-main">
            <div>
              <strong>{{ row.orderNumber }}</strong>
              <small>Trip {{ row.tripNumber }}</small>
            </div>
            <span class="claim-chip" [ngClass]="getStatusClass(row.claimStatus)">
              {{ row.claimStatus }}
            </span>
          </div>

          <div class="trip-meta-row">
            <div class="meta-item">
              <label>Vendor</label>
              <span>{{ row.vendorName }}</span>
            </div>
            <div class="meta-item">
              <label>Vehicle</label>
              <span>{{ row.vehicleNumber }}</span>
            </div>
            <div class="meta-item">
              <label>Advance</label>
              <span>{{ formatAmount(row.advance) }}</span>
            </div>
            <div class="meta-item">
              <label>Proc Amount</label>
              <span>{{ formatAmount(row.baseAmount) }}</span>
            </div>
            <div class="meta-item">
              <label>Claim Amount</label>
              <span>{{ formatAmount(row.claimAmount) }}</span>
            </div>
            <div class="meta-item" *ngIf="row.vendorCharge > 0">
              <label>
                Vendor Charge
                <i
                  class="pi pi-info-circle vendor-charge-info-icon"
                  (click)="chargeOverlay.toggle($event)"
                  (mouseenter)="chargeOverlay.show($event)"
                  (mouseleave)="chargeOverlay.hide()">
                </i>
              </label>
              <span>{{ formatAmount(row.vendorCharge) }}</span>

              <p-overlayPanel #chargeOverlay [dismissable]="true" styleClass="vendor-charge-overlay">
                <div class="vendor-charge-list">
                  <div class="vendor-charge-list-title">Additional Charges</div>
                  <div class="vendor-charge-row" *ngFor="let charge of row.vendorCharges">
                    <div class="charge-type-block">
                      <span class="charge-type">{{ getChargeLabel(charge) }}</span>
                      <small class="charge-remarks" *ngIf="getChargeRemarks(charge)">{{ getChargeRemarks(charge) }}</small>
                    </div>
                    <span class="charge-amount">{{ formatAmount(charge.vendorCharge) }}</span>
                  </div>
                  <div class="vendor-charge-row vendor-charge-total" *ngIf="row.vendorCharges.length > 1">
                    <span class="charge-type">Total</span>
                    <span class="charge-amount">{{ formatAmount(row.vendorCharge) }}</span>
                  </div>
                </div>
              </p-overlayPanel>
            </div>
            <div class="meta-item meta-item-input" *ngIf="row.indemnityEnabled">
              <label>Indemnity Amount <span class="required">*</span></label>
              <input type="text" appIndianNumberFormat class="form-control" formControlName="indemnityAmount" placeholder="Enter amount" />
              <small class="text-danger" *ngIf="isIndemnityInvalid(i)">
                Indemnity amount is required
              </small>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bill-section" [formGroup]="invoiceForm">
      <div class="section-title">
        <span class="section-count">2</span>
        <span>Invoice Details</span>
      </div>

      <div class="invoice-grid">
        <div class="invoice-field">
          <label>Invoice No. <span class="required">*</span></label>
          <input type="text" class="form-control" formControlName="invoiceNo" placeholder="Enter invoice number" />
          <small class="text-danger" *ngIf="isInvalid('invoiceNo')">Invoice number is required</small>
        </div>

        <!-- <div class="invoice-field">
          <label>File URL</label>
          <input type="text" class="form-control" formControlName="fileUrl" placeholder="Paste uploaded invoice file URL" />
        </div> -->

        <div class="invoice-field">
          <label>Invoice Date <span class="required">*</span></label>
          <p-calendar
            formControlName="invoiceDate"
            dateFormat="dd-mm-yy"
            appendTo="body"
            styleClass="w-100"
            inputStyleClass="form-control"
            placeholder="DD-MM-YYYY">
          </p-calendar>
          <small class="text-danger" *ngIf="isInvalid('invoiceDate')">Invoice date is required</small>
        </div>

        <div class="invoice-field">
          <label>GST <span class="required">*</span></label>
          <ng-select
            formControlName="accountGstId"
            [items]="gstList"
            bindLabel="gstNumber"
            bindValue="id"
            [loading]="loadingGst"
            [clearable]="true"
            appendTo="body"
            placeholder="Select GST">
            <ng-template ng-option-tmp let-gst="item">
              {{ getGstLabel(gst) }}
            </ng-template>
            <ng-template ng-label-tmp let-gst="item">
              {{ getGstLabel(gst) }}
            </ng-template>
          </ng-select>
          <small class="text-danger" *ngIf="isInvalid('accountGstId')">GST is required</small>
        </div>

        <div class="invoice-field">
          <label>Upload Invoice <span class="optional-label">(PDF or image)</span></label>
          <div class="file-upload-row">
            <label class="file-upload-btn">
              📎 Choose File
              <input type="file" hidden accept=".pdf,image/*" (change)="onInvoiceFileSelected($event)" />
            </label>
            <span class="file-upload-status" *ngIf="uploadingInvoice">Uploading...</span>
            <span class="file-upload-status success" *ngIf="!uploadingInvoice && invoiceForm.get('fileUrl')?.value">
              ✓ Uploaded
              <a
                [href]="invoiceForm.get('fileUrl')?.value"
                target="_blank"
                rel="noopener noreferrer"
                class="document-link"
                title="View Document">
                <i class="pi pi-link"></i>
              </a>
            </span>
            <span class="file-upload-status" style="font-size: 10px;" *ngIf="!uploadingInvoice && !invoiceForm.get('fileUrl')?.value">No file chosen</span>
          </div>
        </div>

        <div class="invoice-field">
          <label>Advance Amount</label>
          <input type="text" appIndianNumberFormat  class="form-control" formControlName="advanceAmount" readonly />
        </div>

        <div class="invoice-field">
          <label>Claim Amount</label>
          <input type="text" appIndianNumberFormat  class="form-control" formControlName="claimAmount" readonly />
        </div>

        <div class="invoice-field">
          <label>Vendor Charge</label>
          <input type="text" appIndianNumberFormat  class="form-control" formControlName="vendorCharge" readonly />
        </div>

        <div class="invoice-field">
          <label>Indemnity Total</label>
          <input type="text" appIndianNumberFormat  class="form-control" formControlName="indemnityTotal" readonly />
        </div>

        <div class="invoice-field">
          <label>Total Amount</label>
          <input type="text" appIndianNumberFormat  class="form-control" formControlName="totalAmount" readonly />
        </div>

        <div class="invoice-field">
          <label>Balance Payable</label>
          <input type="text" appIndianNumberFormat  class="form-control total-input" formControlName="balancePayable" readonly />
        </div>

        
        <div class="invoice-field">
          <label>Invoice Amount <span class="required">*</span></label>
          <input type="text" appIndianNumberFormat  class="form-control total-input" formControlName="invoiceAmount" placeholder="Enter invoice amount" />
          <small class="text-danger" *ngIf="isInvalid('invoiceAmount')">Invoice amount is required</small>
        </div>

        <div class="invoice-field remarks-field">
          <label>Remarks</label>
          <textarea class="form-control" formControlName="remarks" placeholder="Add remarks"></textarea>
        </div>
      </div>
    </section>

    <div class="bill-actions">
      <button type="button" class="btn btn-secondary" (click)="ref.close()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="invoiceForm.invalid || saving" (click)="generateBill()">
        Generate Bill
      </button>
    </div>
  </ng-container>
</div>